import { Flex } from "@chakra-ui/react";
import { CreativeEngagementRequests } from "../../requests.types";
import { DisplayPerformanceFilters } from "../../types";
import {
  BuyerResearchStageEngagement,
  CreativeFatigueMap,
  CreativeWithHighestEngagement,
  EngagementTestingResults,
  OverallVideoViews,
  VideoCompletionRate,
} from "./components";

type CreativeEngagementProps = {
  id: string;
  filters: DisplayPerformanceFilters;
  requests: CreativeEngagementRequests;
  isBasicView?: boolean;
};

const CreativeEngagement = ({
  id,
  filters,
  requests,
  isBasicView,
}: CreativeEngagementProps) => {
  return (
    <>
      <Flex w="100%" gap={4} mb={4} minH="350px">
        <CreativeWithHighestEngagement
          campaignId={id}
          filters={filters}
          getCreativeWithHighestEngagement={
            requests.getCreativeWithHighestEngagement
          }
          hideCreativePreview={isBasicView}
        />
        <BuyerResearchStageEngagement
          campaignId={id}
          filters={filters}
          getBuyerResearchStageEngagement={
            requests.getBuyerResearchStageEngagement
          }
        />
      </Flex>

      <Flex w="100%" gap={4} mb={4} minH="350px">
        <CreativeFatigueMap
          campaignId={id}
          filters={filters}
          getCreativeFatigueMap={requests.getCreativeFatigueMap}
        />
        <OverallVideoViews
          campaignId={id}
          filters={filters}
          getOverallVideoViews={requests.getOverallVideoViews}
        />
      </Flex>

      <Flex w="100%" gap={4} mb={4} minH="350px">
        <EngagementTestingResults
          campaignId={id}
          filters={filters}
          getEngagementTestingResults={requests.getEngagementTestingResults}
          hideCreativePreview={isBasicView}
        />
        <VideoCompletionRate
          campaignId={id}
          filters={filters}
          getVideoCompletionRate={requests.getVideoCompletionRate}
        />
      </Flex>
    </>
  );
};

export { CreativeEngagement };
